import AttachFileIcon from "@mui/icons-material/AttachFile";
import CancelIcon from "@mui/icons-material/Cancel";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import {
  Avatar,
  Box,
  Divider,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { getDatabase, off, onValue, ref } from "firebase/database";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { allIcons } from "../../assets";
import appcolors from "../../constants/Colors";
import { helper } from "../../helper/uploader";
import Loader from "../Loader";
import { receiveMessage, sendMessage } from "./SendMessage";

const style = {
  incoming: {
    p: "8px 10px",
    backgroundColor: "#F1F1F1",
    borderRadius: "12px",
    alignSelf: "flex-start",
    maxWidth: "70%",
    wordBreak: "break-word",
  },
  outgoing: {
    p: "8px 10px",
    color: appcolors.white,
    backgroundColor: appcolors.primary,
    borderRadius: "12px",
    alignSelf: "flex-end",
    maxWidth: "70%",
    wordBreak: "break-word",
  },
  searchField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      "& .MuiOutlinedInput-notchedOutline": {
        border: `2px solid #F3F3F3`,
        boxShadow: "none",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `2px solid #F3F3F3`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `2px solid #F3F3F3`,
      },
    },
  },
};

function MessageBoxAdmin() {
  const { selectedChat } = useSelector((state) => state.activeChat);
  const { user } = useSelector((state) => state.user);

  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  const [msgValue, setMsgValue] = useState("");
  const [allMessages, setAllMessages] = useState([]);
  const [imgUrl, setImgUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const messageContainerRef = useRef(null);
  const imageRef = useRef();
  let currentUserId = selectedChat?.username == "admin" ? user?._id : selectedBranch[0]
  console.log(currentUserId, 'currentUserIdcurrentUserId');

  useEffect(() => {
    if (selectedChat) {
      try {
        const messagesRef = ref(
          getDatabase(),
          `messages/${currentUserId}/${selectedChat?._id}`
        );


        console.log(messagesRef, 'messagesRefmessagesRef');


        const handleDataSnapshot = (snapshot) => {
          var data = snapshot.val();
          if (data !== null) {
            let tempArr = [];
            Object.keys(data).forEach((key) => {
              const item = data[key];
              tempArr.push({
                sendBy: item?.sender,
                ReceivedBy: item?.receiver,
                msg: item?.msg,
                time: item?.time,
                attachmentUrl: item?.attachmentUrl ? item?.attachmentUrl : null,
              });
            });

            if (messageContainerRef.current) {
              messageContainerRef.current.scrollTop =
                messageContainerRef.current.scrollHeight;
            }
            if (tempArr.length > 0) {
              setAllMessages(tempArr);
            }

            data = null;
            tempArr = [];
          } else {
            setAllMessages([]);
          }
        };

        onValue(messagesRef, handleDataSnapshot);

        // Cleanup the listener when component updates with a new selectedUser
        return () => {
          off(messagesRef, "value", handleDataSnapshot);
        };
      } catch (error) {
        console.log(error, "errorerrorerror");
      }
    }
  }, [selectedChat]);


  const handleSend = () => {
    if (msgValue) {
      setImgUrl(null);
      sendMessage(msgValue, currentUserId, selectedChat._id, imgUrl)
        .then((res) => {
          setMsgValue("");
        })
        .catch((err) => {
          setMsgValue("");

          alert(err);
        });
      receiveMessage(msgValue, currentUserId, selectedChat._id, imgUrl)
        .then(() => {
          setMsgValue("");
        })
        .catch((err) => {
          setMsgValue("");

          alert(err);
        });
      if (messageContainerRef.current) {
        messageContainerRef.current.scrollTop =
          messageContainerRef.current.scrollHeight;
      }
    }
  };

  const onChangePicture = async (e) => {
    let file = e.target.files[0];
    try {
      setIsLoading(true);
      const resss = await helper.uploadMediaService(file);
      setIsLoading(false);
      setImgUrl(resss);
    } catch (error) {
      console.log(error, "errorerrorerror");
      setIsLoading(false);
    }
  };

  return (
    <Paper
      sx={{
        p: 2,
        borderRadius: "10px",
        position: "relative",
        // height: "100%",
      }}
    >
      <Loader isLoading={isLoading} />
      <Stack direction={"row"} alignItems={"center"} gap={2}>
        <Avatar
          sx={{ borderRadius: "100%" }}
          src={selectedChat?.image}
          alt={"No Internet"}
        />
        <Box>
          <Typography
            variant="body1"
            fontSize={"1rem"}
            fontWeight={"bold"}
            fontFamily={"Metropolis"}
          >
            {selectedChat?.username}
          </Typography>
        </Box>
      </Stack>

      <Divider sx={{ my: 1 }} />
      <Stack
        p={1}
        gap={1}
        height={"65vh"}
        overflow={"auto"}
        ref={messageContainerRef}
        sx={{
          "&::-webkit-scrollbar": {
            // display:"none",
            width: "4px",
            height: "8px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: appcolors.primary,
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: appcolors.secondary,
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: appcolors.lightGrey,
          },
        }}
      >
        {allMessages?.map((vallllll, ind) => {
          return (
            <Box
              key={ind}
              sx={
                vallllll.sendBy !== currentUserId ? style.incoming : style.outgoing
              }
            >
              {vallllll?.attachmentUrl && (
                <img
                  src={vallllll?.attachmentUrl}
                  style={{
                    height: "250px",
                    width: "100%",
                    marginTop: "5px",
                    borderRadius: "10px",
                    objectFit: "contain",
                  }}
                />
              )}
              <Typography variant="body2">{vallllll.msg}</Typography>
            </Box>
          );
        })}
      </Stack>

      {imgUrl !== null && (
        <Box
          style={{
            width: "150px",
            height: "150px",
            position: "relative",
            marginLeft: "35px",
            marginBottom: "5px",
          }}
        >
          <Box
            onClick={() => setImgUrl(null)}
            style={{
              position: "absolute",
              height: "25px",
              width: "25px",
              zIndex: 999,
              right: 4,
              top: 4,
              borderRadius: 100,
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <CancelIcon style={{ fontSize: "25px" }} />
          </Box>
          <img
            src={imgUrl}
            style={{ width: "100%", height: "100%", borderRadius: 10 }}
          />
        </Box>
      )}

      <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
        <TextField
          sx={style.searchField}
          fullWidth
          onChange={(e) => setMsgValue(e.target.value)}
          value={msgValue}
          onKeyUp={(e) => e.key === "Enter" && handleSend()}
          placeholder="Type a message"
          InputProps={{
            startAdornment: (
              <Box mr={1}>
                <AttachFileIcon
                  sx={{ transform: "rotate(45deg)", cursor: "pointer" }}
                  onClick={() => imageRef.current.click()}
                />
                <input
                  type="file"
                  style={{ height: 0, width: 0, visibility: "hidden" }}
                  ref={imageRef}
                  onChange={onChangePicture}
                  accept={"image/*"}
                />
              </Box>
            ),
            endAdornment: (
              <Box ml={1} sx={{ cursor: "pointer" }} onClick={handleSend}>
                <img src={allIcons.sendIcon} alt="send-icon" width={20} />
              </Box>
            ),
          }}
        />
      </Box>
    </Paper>
  );
}

export default MessageBoxAdmin;
